export default __webpack_public_path__ + "static/media/bed.18603279.svg";